import { ISO_DATE_FORMAT } from '../../utils/formatters';
import ApiClientInstance from '../../common/ApiClient';

const LIMIT = 30;

export const apiGetAllTransactions = (companyId, accountId,
  offset = 0,
  { end, start }) => ApiClientInstance.get(`api/accountants/company/transactions/${accountId}?limit=${LIMIT}&offset=${offset}&date_start=${start.format(ISO_DATE_FORMAT)}&date_end=${end.format(ISO_DATE_FORMAT)}${companyId ? `&company_id=${companyId}` : ''}`, undefined, true);
